<div class="form-web-post-data" [formGroup]="form">
  <div class="form-header">
    <button
      type="button"
      class="btn btn-transparent"
      (click)="addItem()"
      [disabled]="itemsArray.length >= 10"
      >
      <i class="fas fa-plus"></i> {{ "NEW_INJECTS.ADD_POST" | translate }}
    </button>
  </div>

  @if (itemsArray.length > 0) {
    <div class="items-container">
      @for (item of itemsArray.controls; track item; let i = $index) {
        <div
          class="item-card"
          [formGroup]="item"
          >
          <div class="item-header">
            <h5>{{ "NEW_INJECTS.POST" | translate }} {{ i + 1 }}</h5>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              (click)="removeItem(i)"
              [disabled]="itemsArray.length <= 1"
              >
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label [for]="'date_time_' + i">
                {{ "NEW_INJECTS.DATE_TIME" | translate }}</label
                >
                <input
                  type="datetime-local"
                  class="form-control"
                  [id]="'date_time_' + i"
                  formControlName="date_time"
                  placeholder="Select date and time"
                  />
              </div>
            </div>
            <div class="languages-section">
              <span class="label"> {{ "NEW_INJECTS.TITLE" | translate }}</span>
              <div class="language-inputs" formGroupName="title">
                @for (lang of languages; track lang) {
                  <div class="form-group">
                    @if (item.get('title')?.contains(lang)) {
                      <div
                        class="mat-form-field-wrapper"
                        >
                        <mat-form-field class="full-width">
                          <input
                            matInput="matInput"
                            [formControlName]="lang"
                            [placeholder]="lang"
                            autocomplete="off"
                            />
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }
              </div>
              <span class="label">{{
                "ADMIN.SESSION.ITEM_CATEGORY.text" | translate
              }}</span>
              <div class="language-inputs" formGroupName="text">
                @for (lang of languages; track lang) {
                  <div class="form-group">
                    @if (item.get('text')?.contains(lang)) {
                      <div>
                        <mat-form-field class="full-width">
                          <textarea
                            matInput="matInput"
                            class="form-control"
                            rows="3"
                            [id]="'text_' + lang + '_' + i"
                            [formControlName]="lang"
                            [placeholder]="lang"
                          ></textarea>
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (itemsArray.length === 0) {
      <div class="no-items">
        <p class="text-muted">No items added yet. Click "Add Item" to start.</p>
      </div>
    }
  </div>
